import { render, staticRenderFns } from "./PromotionShopStatus.vue?vue&type=template&id=0d03e4ff"
import script from "./PromotionShopStatus.vue?vue&type=script&lang=js"
export * from "./PromotionShopStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports